import { gql } from '@apollo/client'
import { useSessionActions, useSessionState, useLogout } from '@btime/react-session'
import React from 'react'

import { INVALID_SESSION, hasError, messageError } from './authErros'
import { getProjectId, setLoggedUser, setPermissions } from './sessionStorage'
import { sessionsClient } from '../apollo/api'
import { useOpenCreateStrongPasswordModal, useOpenTypeFormModal } from '../routes/modals/modalsActions'
import campaigns from '../constants/campaigns'

const QUERY = gql`
  query Session {
    session {
      permissions {
        id
        name
        enabled
      }
      user {
        id
        hasWeakPassword
        canAccessPaymentModule
        master
        viewedCampaigns {
          campaignId
        }
        contract {
          id
          profile {
            id
            name
          }
        }
      }
    }
  }
`

const handleInvalidSession = (errors, onError) => {
  const isInvalid = hasError(errors, INVALID_SESSION)
  if (isInvalid && typeof onError === 'function') {
    onError(messageError(errors))
  }
}

export const useReloadLoggedUser = () => {
  const { setSession } = useSessionActions()
  const session = useSessionState()
  const logout = useLogout()
  const openChangePasswordModal = useOpenCreateStrongPasswordModal()
  const handleCampaigns = useHandleCampaigns()

  return () => {
    const projectId = getProjectId()
    if (session.user?.id && projectId) {
      console.log('RELOADING LOGGED USER')
      const path = document.location.pathname

      sessionsClient
        .query({ query: QUERY })
        .then(({ data, errors }) => {
          if (errors) return handleInvalidSession(errors, logout)
          if (data?.session?.user?.hasWeakPassword) openChangePasswordModal()
          if (data) {
            const permissions = data?.session?.permissions
            const newSession = { ...session, projectId, permissions, user: { ...session.user, ...data?.session?.user } }
            setPermissions(permissions)
            setSession(newSession)
            setLoggedUser(newSession.user)
            //handleCampaigns(newSession)
          }
        })
        .catch(err => console.log('err', err))
    }
  }
}

const useHandleCampaigns = () => {
  const openTypeFormModal = useOpenTypeFormModal()
  return ({ user }) => {
    const viewedCampaign = user?.viewedCampaigns?.filter(item => item?.campaignId === campaigns.NPS_SURVEY)?.length
    const shouldShowCampaign = user?.contract.profile.name !== 'owner'
    !viewedCampaign &&
      shouldShowCampaign &&
      !user?.hasWeakPassword &&
      openTypeFormModal({ campaignId: campaigns.NPS_SURVEY })
  }
}

export const useLoggedUserAutoReloader = (options = {}) => {
  const session = useSessionState()
  const reloadUser = useReloadLoggedUser()

  React.useEffect(() => {
    reloadUser()
  }, [session.user?.id])
}
